/* @flow */

import * as React from 'react';
import ReactTooltip from 'react-tooltip';

import classnames from 'classnames';

import {Badge} from '../../badge';
import type {Props as BadgeProps} from '../../badge/badge';

import './icon-button.module.css';

type ButtonBadgeProps = {|
    ...$Exact<BadgeProps>,
    shouldShow: boolean,
|};

type Props = {
    // TODO: Make this work, maybe needs newer than flow 0.53?
    // ...HTMLButtonElement,
    icon: React.ComponentType<*>,
    text?: string | number,
    onClick: (e: SyntheticEvent<*>) => void,
    getButtonRef?: any,
    variant?: 'primary' | 'danger' | 'ai',
    noHoverBackground?: boolean,
    tooltipText?: string,
    isSmall?: boolean,
    isDisabled?: boolean,
    size?: null | string | number,
    noPadding?: boolean,
    alignCenter?: boolean,
    forceHover?: boolean,
    useBlueIcon?: boolean,
    color?: string,
    badgeProps?: ButtonBadgeProps,
};

export const IconButton = (props: Props) => {
    React.useEffect(() => {
        ReactTooltip.rebuild();

        return () => ReactTooltip.hide();
    });

    const {
        icon: Icon,
        variant,
        noHoverBackground,
        getButtonRef,
        tooltipText,
        isSmall,
        isDisabled,
        size = 16,
        noPadding,
        alignCenter,
        useBlueIcon,
        forceHover,
        color,
        badgeProps,
        ...htmlButtonProps
    } = props;

    const buttonStyles = classnames('icon-button', variant, {
        'icon-button--small': isSmall,
        'icon-button--blue': useBlueIcon,
        'no-hover-bg': noHoverBackground,
        disabled: isDisabled, // done this way to allow hover text but style as disabled
        'no-padding': noPadding,
        'force-hover': forceHover,
    });

    const buttonElement = (
        <button
            type='button'
            styleName={buttonStyles}
            onClick={props.onClick}
            {...htmlButtonProps}
            ref={getButtonRef}
            data-tip={tooltipText}
        >
            <Icon
                wrapWithDiv={false}
                size={size}
                alignCenter={alignCenter}
                color={color}
                fill={color}
            />
            {props.text ? <span styleName='button-text'>{props.text}</span> : undefined}
        </button>
    );

    if (badgeProps && badgeProps.shouldShow) {
        return (
            <div className='pos-relative'>
                {buttonElement}
                <Badge
                    color={badgeProps.color}
                    shouldFlash={badgeProps.shouldFlash}
                    contents={badgeProps.contents}
                />
            </div>
        );
    }

    return buttonElement;
};
